import { render, staticRenderFns } from "./adminDashboard.vue?vue&type=template&id=03980f57&scoped=true"
import script from "./adminDashboard.vue?vue&type=script&lang=js"
export * from "./adminDashboard.vue?vue&type=script&lang=js"
import style0 from "./adminDashboard.vue?vue&type=style&index=0&id=03980f57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03980f57",
  null
  
)

export default component.exports